import type { ResearchFile } from '../domains/socket';
import { formatScratchpadSize } from './scratchpad';

// What the file card under an Ask answer says about a file the assistant wrote
// (code execution, apps/server/src/helpers/vaultAgentFile.ts). Shared so the four
// cards — Oakbox web and app, factiii.com web and app — say the same thing.

/** `Taxes/2026/summary.md` → `summary.md`. */
export const researchFileName = (path: string): string =>
  path.slice(path.lastIndexOf('/') + 1);

/** `Taxes/2026/summary.md` → `Taxes/2026`; '' at the top of their files. */
const researchFileFolder = (path: string): string =>
  path.includes('/') ? path.slice(0, path.lastIndexOf('/')) : '';

/** The card's second line: where it went, how big, and what state it is in. */
export const researchFileMeta = (file: ResearchFile): string => {
  const folder = researchFileFolder(file.path);
  const where = folder ? `In ${folder}` : 'In your files';
  const size = formatScratchpadSize(file.size);
  switch (file.status) {
    case 'saved':
      return `${where} · ${size}`;
    case 'saving':
      return `Saving to ${folder || 'your files'}…`;
    case 'confirm':
      return 'A file with this name is already there. Replace it?';
    case 'duplicate':
      return 'Same as a file you already have. Check Add to keep or discard it.';
    case 'discarded':
      return 'Not saved';
    case 'failed':
      return file.error ?? 'Could not save it';
  }
};
